import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { apiClient } from '@/shared/lib/api';
import type { OutputStyle } from '@/types/output-style';

const OUTPUT_STYLES_KEY = 'output-styles';

export function useOutputStyles() {
  const locale = useLocale();
  return useQuery({
    queryKey: [OUTPUT_STYLES_KEY, locale],
    queryFn: async () => {
      const response = await apiClient.get<{ data: OutputStyle[] }>(
        '/v1/output-styles'
      );
      return response.data;
    },
    staleTime: 60 * 60 * 1000, // 1 hour
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
}
